/**
 * Configuration that can be safely shared with frontend
 */

export const ANALYTICS_CONFIG = {
  // Umami website ID - get this from your Umami dashboard
  websiteId: '58ace751-14ad-4178-bba2-796ab52a4c84',

  // Script source path (first-party tracking via Next.js rewrite)
  scriptSrc: '/uscript',

  // Send API requests to this path (proxied via Next.js rewrite)
  apiPath: '/usync',

  // Share URL for admin analytics dashboard
  shareUrl: 'https://analytics.mrfin.app/share/OC8Wq84XyPe21giF',

  // Umami host URL (used for backend tracking and API calls)
  hostUrl: 'https://analytics.mrfin.app',

  analyticsWebsiteUrl: 'https://analytics.mrfin.app/websites/58ace751-14ad-4178-bba2-796ab52a4c84',
} as const;
